export function formatCurrency(value: number) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

/** Nombre arrondi à l'unité, séparateur de milliers français (ex. surface : « 4 000 »). */
export function formatNumber(value: number) {
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(value)
}

export function formatCurrencyWithoutSymbol(value: number) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'decimal',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}
